import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgBusyModule } from 'ng-busy';
import {
  CalendarModule,
  DialogModule,
  GrowlModule,
  MultiSelectModule,
  TooltipModule,
  TreeModule
} from 'primeng/primeng';

import { NecCommonServiceModule } from '../service/common-service.module';
import { NecAutoSizeDirective } from './auto-size/auto-size.directive';
import { NecCascadeComponent } from './cascade/cascade.component';
// import { NecCategorySelectComponent } from './category/category-select.component';
import { NecClassificationOptionSelectComponent } from './classification/classification-option-select/classification-option-select.component';
import { NecClassificationSelectComponent } from './classification/classification-select/classification-select.component';
import { NecClassificationInterface } from './classification/classification.interface';
import { NecClassificationService } from './classification/classification.service';
import { CommonComponentRoutes } from './common-component.routing';
import { NecCrumbsComponent } from './crumbs/crumbs.component';
import { NecDatePickerComponent } from './datepicker/datepicker.component';
import { NecDeptTreeComponent } from './dept-tree/dept-tree.component';
import { DeptTreeService } from './dept-tree/dept-tree.service';
import { NecDropDownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { NecFolderTreeComponent } from './folder-tree/nec-folder-tree.component';
import { NecCopyrightComponent } from './footer/footer-link/copyright.component';
import { NecDisclaimerComponent } from './footer/footer-link/disclaimer.component';
import { NecPrivacyComponent } from './footer/footer-link/privacy.component';
import { NecFooterComponent } from './footer/footer.component';
import { NecHeaderComponent } from './header/header.component';
import { HeaderService } from './header/header.service';
import { NecTenantAdminAccountInterface } from './header/tenant-admin-account.interface';
import { NecTenantAdminAuthCodeService } from './header/tenant-admin-auth-code.service';
import { NecHomeComponent } from './home/home/home.component';
import { NecMoocInfoComponent } from './home/mooc-info/mooc-info.component';
import { NecMoocTestComponent } from './home/mooc-test/mooc-test.component';
import { NecMoreInfoComponent } from './home/more-info/more-info.component';
import { NecXiaoXiangComponent } from './home/xiao-xiang/xiao-xiang.component';
import { NecXiaoXiangInterface } from './home/xiao-xiang/xiao-xiang.interface';
import { NecLearnCertComponent } from './learncert/learncert.component';
import { NecLearnCertInterface } from './learncert/learncert.interface';
import { NecLearnCertService } from './learncert/learncert.service';
import { NecLeftNavComponent } from './left-nav/left-nav.component';
import { NecLoadingComponent } from './loading/loading.component';
import { NecLoadingService } from './loading/loading.service';
import { NecLoginComponent } from './login/login.component';
import { NecOfficePreviewComponent } from './office-preview/office-preview.component';
import { NecPaginationComponent } from './pagination/pagination.component';
import { NecSearchBoxManualComponent } from './search-box/search-box-manual.component';
import { NecSearchComponent } from './search/search.component';
import { NecMultiScaleSelectComponent } from './selects/multi-scale-select/multi-scale-select.component';
import { NecMultiSelectComponent } from './selects/multi-select/multi-select.component';
import { NecSingleSelectComponent } from './selects/single-select/single-select.component';
import { NecYearSelectComponent } from './selects/year-select/year-select.component';
import { NecSingleInputDialogComponent } from './single-input-dialog/single-input-dialog.component';
import { NecSlideComponent } from './slide/slide.component';
import { NecStepHeaderComponent } from './step-header/step-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(CommonComponentRoutes),
    CalendarModule,
    GrowlModule,
    DialogModule,
    MultiSelectModule,
    TooltipModule,
    TreeModule,
    BrowserAnimationsModule,
    NgBusyModule,
    NecCommonServiceModule
  ],
  exports: [
    CalendarModule,
    GrowlModule,
    DialogModule,
    MultiSelectModule,
    NgBusyModule,
    TooltipModule,
    TreeModule,
    NecAutoSizeDirective,
    NecCascadeComponent,
    NecClassificationOptionSelectComponent,
    NecClassificationSelectComponent,
    NecCopyrightComponent,
    NecCrumbsComponent,
    NecDatePickerComponent,
    NecDeptTreeComponent,
    NecDisclaimerComponent,
    NecDropDownMenuComponent,
    NecFolderTreeComponent,
    NecFooterComponent,
    NecHeaderComponent,
    NecHomeComponent,
    NecLearnCertComponent,
    NecLeftNavComponent,
    NecLoginComponent,
    NecMoreInfoComponent,
    NecMoocInfoComponent,
    NecMoocTestComponent,
    NecMultiScaleSelectComponent,
    NecMultiSelectComponent,
    NecOfficePreviewComponent,
    NecPaginationComponent,
    NecPrivacyComponent,
    NecSearchComponent,
    NecSearchBoxManualComponent,
    NecSingleSelectComponent,
    NecSingleInputDialogComponent,
    NecSlideComponent,
    NecStepHeaderComponent,
    NecXiaoXiangComponent,
    NecYearSelectComponent
  ],
  declarations: [
    NecAutoSizeDirective,
    NecCascadeComponent,
    NecClassificationOptionSelectComponent,
    NecClassificationSelectComponent,
    NecCopyrightComponent,
    NecCrumbsComponent,
    NecDatePickerComponent,
    NecDeptTreeComponent,
    NecDisclaimerComponent,
    NecDropDownMenuComponent,
    NecFooterComponent,
    NecHeaderComponent,
    NecHomeComponent,
    NecMoreInfoComponent,
    NecMoocInfoComponent,
    NecMoocTestComponent,
    NecXiaoXiangComponent,
    NecLearnCertComponent,
    NecLeftNavComponent,
    NecLoadingComponent,
    NecLoginComponent,
    NecMultiScaleSelectComponent,
    NecMultiSelectComponent,
    NecPaginationComponent,
    NecPrivacyComponent,
    NecSearchComponent,
    NecSearchBoxManualComponent,
    NecSingleSelectComponent,
    NecSingleInputDialogComponent,
    NecSlideComponent,
    NecStepHeaderComponent,
    NecYearSelectComponent,
    NecOfficePreviewComponent,
    NecFolderTreeComponent
  ],
  providers: [
    DeptTreeService,
    HeaderService,
    NecClassificationInterface,
    NecClassificationService,
    NecLearnCertInterface,
    NecLearnCertService,
    NecLoadingService,
    NecXiaoXiangInterface,
    NecTenantAdminAccountInterface,
    NecTenantAdminAuthCodeService
  ],
  entryComponents: [
    NecCascadeComponent,
    NecClassificationOptionSelectComponent,
    NecClassificationSelectComponent,
    NecCopyrightComponent,
    NecCrumbsComponent,
    NecDatePickerComponent,
    NecDeptTreeComponent,
    NecDisclaimerComponent,
    NecDropDownMenuComponent,
    NecFooterComponent,
    NecHeaderComponent,
    NecHomeComponent,
    NecMoreInfoComponent,
    NecMoocInfoComponent,
    NecMoocTestComponent,
    NecXiaoXiangComponent,
    NecLearnCertComponent,
    NecLeftNavComponent,
    NecLoadingComponent,
    NecLoginComponent,
    NecMultiScaleSelectComponent,
    NecMultiSelectComponent,
    NecPaginationComponent,
    NecPrivacyComponent,
    NecSearchComponent,
    NecSearchBoxManualComponent,
    NecSingleSelectComponent,
    NecSingleInputDialogComponent,
    NecSlideComponent,
    NecStepHeaderComponent,
    NecYearSelectComponent,
    NecFolderTreeComponent
  ]
})
export class NecCommonComponentModule { }
